export const apiConfig = {
  authHost: import.meta.env.VITE_AUTH_API_URL,
  apiHost: import.meta.env.VITE_API_URL,
  tristarGamesHost: import.meta.env.VITE_TRISTAR_GAMES_URL,
};
